export default __webpack_public_path__ + "static/media/0fa6557efc006743.8e3e62b25534126a90b1a0998e5c7079.svg";